import styled from 'styled-components'
import { TableColumnType } from './PredictionTableHead'

interface PredictionTableBodyProps<T> {
  tableColumns: TableColumnType<T>[]
  tableDataList: T[]
}

const PredictionTableBody = <T extends object>({
  tableDataList,
  tableColumns,
}: PredictionTableBodyProps<T>) => {
  return (
    <StyledWrapper>
      {tableDataList.map((data, index) => {
        return (
          <tr key={index}>
            {tableColumns.map((column, index) => {
              return column.render ? (
                <td key={`${column.id}-${index}`}>{column.render(data)}</td>
              ) : (
                <td key={`${column.id}-${index}`} className="basic-body">
                  {data[column.dataIndex]}
                </td>
              )
            })}
          </tr>
        )
      })}
    </StyledWrapper>
  )
}

export default PredictionTableBody

const StyledWrapper = styled.tbody`
  > tr {
    &:first-child {
      border-left: none;
    }
    &:last-child {
      border-right: none;
    }

    > .basic-body {
      padding: 14px 0px;
      &:empty {
        &::before {
          content: '-';
        }
      }
    }
    > td {
      border: 1px solid #eeeeee;
      font-size: 16px;
      font-weight: normal;
      letter-spacing: -0.64px;
      text-align: center;
      color: #333;
    }
  }
`
